/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMessageCircleUser = createReactComponent("outline", "message-circle-user", "IconMessageCircleUser", [["path", { "d": "M19 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M22 22a2 2 0 0 0 -2 -2h-2a2 2 0 0 0 -2 2", "key": "svg-1" }], ["path", { "d": "M12.454 19.97a9.9 9.9 0 0 1 -4.754 -.97l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.667 1.423 2.596 3.294 2.747 5.216", "key": "svg-2" }]]);

export { IconMessageCircleUser as default };
//# sourceMappingURL=IconMessageCircleUser.mjs.map
